// Load the AWS SDK
const { REACT_APP_ENVIRONMENT } = process.env;
const AWS = require('aws-sdk'),
  region = 'eu-west-2',
  secretName = `${REACT_APP_ENVIRONMENT}-localStorageAES`;

// Create a Secrets Manager client
const client = new AWS.SecretsManager({
  region: region
});

export async function retrieveSecret() {
  return new Promise((resolve, reject) => {
    client.getSecretValue({ SecretId: secretName }, function (err, data) {
      if (err) {
        reject(new Error('Secrets Manager cant find the specified secret'));
      } else {
        let secret = JSON.parse(data.AESKey);
        console.log('SM Key--->', secret.AESKey);
        resolve(secret.AESKey);
      }
    });
  });
};